/**
 * @file paddle hack topic
 * @author wanzhongyun
 */

import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { IHackTopic } from './../../type';

import './style.less';


const HackTopic: React.FC<IHackTopic> = props => {
    
    const {
        titleImageUrl,
        topicList,
        allTopicWord,
        allTopicLink
    } = props;

    return (
        <div className='paddle-hack-topic-wrapper'>
            <img className='paddle-hack-topic-title' src={titleImageUrl} alt='' />
            <div className='paddle-hack-topic-card-wrapper'>
                {
                    topicList.map(item => <div className='paddle-hack-topic-card' key={item.titleEn} onClick={() => {window.open(item.checkAllLink)}}>
                        <img className='paddle-hack-topic-card-icon' src={item.imageUrl} alt={item.titleZh} />
                        <div className='paddle-hack-topic-card-en-title'>{item.titleEn}</div>
                        <div className='paddle-hack-topic-card-zh-title'>{item.titleZh}</div>
                        <div className='paddle-hack-topic-desc'>{item.desc}</div>
                        <div className='paddle-hack-topic-check-all'>
                            <span className='paddle-hack-topic-check-all-word'>{item.checkAll}</span>
                            <span className='paddle-hack-topic-check-arrow' />
                        </div>
                    </div>)
                }
            </div>
            <div className='paddle-hack-topic-all-link'>
                <a href={allTopicLink} target='_blank' rel="noreferrer" >{ allTopicWord }<RightOutlined className='paddle-pilot-rights-detail-link-icon' /></a>
            </div>
        </div>
    );
};

export default HackTopic;